import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RegisterProductSelector from '../components/RegisterProductSelector';
import './RegisterProduct.css';
import { toggleModal } from '../lib/util';

class RegisterProduct extends Component {
  constructor() {
    super();
    this.state = {
      modalActive: false,
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  toggleModal() {
    this.setState({
      modalActive: !this.state.modalActive,
    }, () => toggleModal(this.state.modalActive));
  }

  handleClick(product) {
    this.props.handleObjectChange({ product });
  }

  render() {
    return (
      <React.Fragment>
        <div className="field is-horizontal">
          <div className="field-label is-medium">
            <label className="label">購買產品</label>
          </div>
          <div>
            <div className="field is-grouped">
              <div className="control selected-product" id="register-product-select">
                {this.props.product ? `${this.props.product.title} ${this.props.product.chinese_title}` : '未選取產品'}
              </div>
              <div className="control">
                <button className="App-skew-button is-primary" onClick={this.toggleModal}>
                  <div>選擇產品</div>
                </button>
              </div>
            </div>
              <div className="help-wrapper">
                <p className="help is-danger">{'必填'}</p>
              </div>
          </div>
        </div>
        <div className={`modal product-selector ${this.state.modalActive ? 'is-active' : ''}`}>
          <div className="modal-background" onClick={this.toggleModal} />
          <div className="modal-content">
            <RegisterProductSelector
              products={this.props.products}
              categories={this.props.categories}
              handleClick={this.handleClick}
              toggleModal={this.toggleModal}
            />
          </div>
          <button className="modal-close is-large" aria-label="close" onClick={this.toggleModal} />
        </div>
      </React.Fragment>
    );
  }
}

RegisterProduct.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
  products: PropTypes.arrayOf(PropTypes.object),
  handleObjectChange: PropTypes.func.isRequired,
};

RegisterProduct.defaultProps = {
  categories: [],
  products: [],
};

export default RegisterProduct;



// WEBPACK FOOTER //
// ./src/containers/RegisterProduct.js